import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=2ed87c05&lang=pug&"
import script from "./CustomDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports